import { useAppSelector } from 'store/hooks';
import React from 'react';
import { styled } from '@mui/material';
import { MuiModal } from 'ui/MuiModal';
import { AddVoucherEffectFormData, VoucherAddEffectsForm } from '../forms/VoucherAddEffectsForm';
import { Voucher } from '../models/VoucherModel';

const StyledMuiModal = styled(MuiModal)(({ theme }) => ({
    width: theme.spacing(60),
    padding: theme.spacing(2)
}));

interface CreateVoucherEffectsModalProps {
    open: boolean;
    onClose?: () => void;
    onSubmit: (values: AddVoucherEffectFormData) => void;
    voucher: Voucher;
}

export const AddVoucherEffectsModal: React.FunctionComponent<CreateVoucherEffectsModalProps> = props => {
    const { open, onClose, onSubmit, voucher } = props;
    const { perks } = useAppSelector(state => state.perks);
    const { audiences } = useAppSelector(state => state.audiences);

    const perksOptions = React.useMemo(
        () => perks.map(item => ({ value: item._id, label: item.title })),
        [perks]
    );
    const audiencesOptions = React.useMemo(
        () => audiences.map(item => ({ value: item._id, label: item.title })),
        [audiences]
    );

    return (
        <StyledMuiModal open={open} onClose={onClose}>
            <VoucherAddEffectsForm
                onSubmit={onSubmit}
                onClose={onClose}
                perksOptions={perksOptions}
                audiencesOptions={audiencesOptions}
                voucher={voucher}
            />
        </StyledMuiModal>
    );
};
